"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Label = exports.TabWrapper = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const colors_1 = require("../../../theme/colors");
exports.TabWrapper = styled_components_1.default.div `
  display: flex;
  align-items: center;
  justify-content: center;
  border-bottom: 1px solid ${colors_1.GREY1};
  border-right: 1px solid ${colors_1.GREY1};
  width: ${({ $fitContent }) => ($fitContent ? "auto" : "100%")};
  padding: ${({ $fitContent }) => ($fitContent ? "0 32px 0" : 0)};
  background: ${colors_1.LIGHT_GREY};
  &:hover {
    cursor: pointer;
  }
  ${({ $active }) => $active &&
    (0, styled_components_1.css) `
      color: ${colors_1.SWEGON_GREEN};
      border: 0;
      border-right: 1px solid ${colors_1.GREY1};
      background: ${colors_1.WHITE};
    `}
`;
exports.Label = styled_components_1.default.h3 `
  color: ${({ $active }) => ($active ? colors_1.SWEGON_GREEN : colors_1.GREY4)};
`;
//# sourceMappingURL=Tab.styles.js.map